import { render } from "./TeacherNavTab.vue?vue&type=template&id=0b50c1a3&scoped=true"
import script from "./TeacherNavTab.vue?vue&type=script&lang=js"
export * from "./TeacherNavTab.vue?vue&type=script&lang=js"

import "./TeacherNavTab.vue?vue&type=style&index=0&id=0b50c1a3&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b50c1a3"]])

export default __exports__